export default 'marketingRemindersPage';
